export const LOCATION_TYPES = {
    NORMAL: 1,
    LITE: 2,
};

